import { Ref } from 'vue';
import {
  Trans, FieldHtmlNameUtil, HekateDisplayField, HekateDisplayForm,
} from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

/** Only show fields that can't be sso filled, redirect to login if the user is not logged in  */
export default class RenderStudioUpgradeProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public async realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>,
  }): Promise<void> {
    super.realtimeBranchModifications({ formDefinition });

    // submit should only be enabled if the user is logged in to the product
    const submit = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.submit });
    submit.isDisabled = true;

    const firstName = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.firstName });
    const lastName = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.lastName });
    const email = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.email });

    const toHide: HekateDisplayField[] = [
      firstName,
      lastName,
      email,
    ];
    toHide.forEach((field) => {
      field.componentName = 'hidden-field';
    });

    const sso = await ExternalUtil.sso.getSsoData();
    // if not logged in show error message and redirect to download
    if (!sso) {
      ExternalUtil.scrollToTopOfForm({ formId: formDefinition.value.id });
      formDefinition.value.errorMessages.push({
        message: Trans.byKey('mustBeLoggedIn'),
      });
      ExternalUtil.redirectToLogin({ delay: 3000, returnTo: 'upgrade-render-studio' });
      return;
    }

    submit.isDisabled = false;
    firstName.val = sso.firstName;
    lastName.val = sso.lastName;
    email.val = sso.email;
  }
}
